import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'
import { ArrowDown2 } from 'iconsax-react'

import ButtonMenu from '../ButtonMenu'
import StatusOption from '../../atoms/StatusOption'

import { fetchUserStatus, selectUserStatus } from '@SonarCX/slices/userStatus'

import useStyles from './styles'

interface StatusMenuProps {
  selected: string
  onSelect: CallableFunction
  id?: string
  className?: string
  disabled?: boolean
}
const StatusMenu: React.FC<StatusMenuProps> = ({
  selected,
  onSelect,
  className,
  disabled,
  id,
  ...props
}) => {
  const dispatch = useAppDispatch()
  const { loaded, loading, statuses } = useAppSelector(selectUserStatus)

  const options = React.useMemo(
    () => ['null', ...statuses.map(status => status.id)],
    [statuses]
  )

  const classes = useStyles({ disabled })

  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchUserStatus())
    }
  }, [dispatch, loaded, loading])

  const getStatusName = React.useCallback(
    id => {
      return <StatusOption id={id} loaded={loaded} statuses={statuses} />
    },
    [statuses, loaded]
  )

  if (disabled) {
    return <label>{getStatusName(selected)}</label>
  }

  return (
    <>
      {/* @ts-ignore */}
      <ButtonMenu
        options={options}
        onSelect={onSelect}
        selected={selected ?? 'null'}
        renderFunc={getStatusName}
        className={className ?? classes.root}
        disabled={disabled}
        id={id}
        {...props}
      >
        {getStatusName(selected)}

        <ArrowDown2 className={classes.icon} />
      </ButtonMenu>
    </>
  )
}

export default StatusMenu
